import { render, staticRenderFns } from "./LeasingPrescorePsd2Sync.vue?vue&type=template&id=4d688162&scoped=true&"
import script from "./LeasingPrescorePsd2Sync.vue?vue&type=script&lang=js&"
export * from "./LeasingPrescorePsd2Sync.vue?vue&type=script&lang=js&"
import style0 from "./LeasingPrescorePsd2Sync.vue?vue&type=style&index=0&id=4d688162&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d688162",
  null
  
)

export default component.exports